import { scrollTop, onScroll } from '../utils/scroll.js';
import { currentWindowHeight } from '../utils/window-resize.js';

export function setupImageScale(selector = '[data-image-scale]') {
    const imageContainers = document.querySelectorAll(selector);
    imageContainers.forEach(container => {
        const image = container.hasAttribute('data-image-scale-selector') ? container.querySelector(container.getAttribute('data-image-scale-selector')) : container.querySelector('img');

        if (image) {
            const top = container.getBoundingClientRect().top + scrollTop - (currentWindowHeight * 0.66);
            const height = container.scrollHeight;
            container.setAttribute('data-top', top);
            container.setAttribute('data-height', height);
            container.setAttribute('data-bottom', parseInt(top) + height);
        }
    });

    const scrollHandler = () => {
        imageContainers.forEach(container => {
            const image = container.hasAttribute('data-image-scale-selector') ? container.querySelector(container.getAttribute('data-image-scale-selector')) : container.querySelector('img');

            if (image) {
                const top = parseInt(container.getAttribute('data-top'));
                const height = parseInt(container.getAttribute('data-height'));
                const bottom = parseInt(container.getAttribute('data-bottom'));

                if (scrollTop >= top && scrollTop <= bottom) {
                    const scrolledPastTop = scrollTop - top;
                    const scrollDiff = normalize((height) - ((height) - scrolledPastTop), 0, (height)) / 10;
                    const scaleValue = 1.1 - scrollDiff;
                    image.style.transform = `translateZ(0) scale(${scaleValue})`;
                } else if (scrollTop < top) {
                    image.style.transform = 'translateZ(0) scale(1.1)';
                } else if (scrollTop > bottom) {
                    image.style.transform = 'translateZ(0) scale(1)';
                }
            }
        });
    };

    onScroll(scrollHandler, true);
}

function normalize(val, min, max) {
    return (val - min) / (max - min);
}
